module.exports = __webpack_public_path__ + "static/media/1.7d38e0ac.svg";